<template>
  <v-combobox ref="comboBox" :clearable="clearable" :multiple="multiple" open-on-clear :loading="isSearching" :search-input.sync="search" :persistent-hint="persistentHint" :hint="hint" no-filter class="mt-2" v-model="selectedItem" :label="label" :rules="rules" :solo="solo" :items="filteredItems" item-text="primaryName" item-value="primaryName" return-object>
    <template v-if="!defaultItemSelection" v-slot:item="{ item, index }">
      <slot name="item" :item="item" :index="index">
        <v-list-tile-content>
          <v-list-tile-title :class="{ 'info--text': value && item.id == value.id }">
            {{ item.primaryName }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <span v-if="item.allNames.length">Data types: </span>
            <v-chip small v-for="(dataType, subIindex) in item.dataTypes" :key="subIindex">
              {{ dataType.type }}
            </v-chip>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </slot>
    </template>
  </v-combobox>
</template>

<script>
  import {
    debounce,
    defaultDebounceDelay,
  } from '@/helpers/performance'

  import {
    getObjectValues,
    customSearcher,
  } from '@/helpers/search'

  export default {
    props: {
      label: {
        type: String,
        default: 'Select station location',
      },
      searchableLocationItems: {
        type: Array,
        default: () => [],
      },
      value: [Object, Array],
      solo: Boolean,
      persistentHint: Boolean,
      defaultItemSelection: Boolean,
      hint: String,
      multiple: Boolean,
      rules: [Object, Array],
      clearable: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      search: '',
      filteredItems: [],
      isSearching: false,
      menu: false,
      selectedItem: null,
    }),
    computed: {
      searchItemsIndex() {
        let index = {}
        this.searchableLocationItems.forEach(item => index[item.id] = item)
        return index
      },
      searchItemValues() {
        let index = {}
        this.searchableLocationItems.forEach(item => {
          let result = getObjectValues(item, 'primaryName', 'allNames')
          index[item.id] = result
        })
        return index
      },
      customSearch() {
        return customSearcher(this.searchItemValues, 'id')
      },
      onSearch() {
        return debounce(function executable(value) {
          let items = this.customSearch(this.searchableLocationItems, value)
          this.filteredItems = items
          this.isSearching = false
        }, defaultDebounceDelay)
      },
    },
    watch: {
      searchableLocationItems: {
        immediate: true,
        handler(value) {
          this.filteredItems = value
        },
      },
      search() {
        this.isSearching = true
        this.onSearch(this.search)
      },
      selectedItem(value) {
        if (value === null || value instanceof Object) {
          this.$emit('input', value)
        } else {
          this.$emit('input', null)
        }
      },
    },
    methods: {},
  }
</script>